// StarRating.js
import React from 'react';

function StarRating({ rating }) {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
        if (i <= rating) {
            stars.push(<i key={i} className="fas fa-star"></i>); // Full star
        } else if (i - rating < 1) {
            stars.push(<i key={i} className="fas fa-star-half-alt"></i>); // Half star
        } else {
            stars.push(<i key={i} className="far fa-star"></i>); // Empty star
        }
    }
    return <div className="star-rating">{stars}</div>;
}

export default StarRating;
